import Vue from 'vue';
import App from './App.vue';

import Axios from 'axios';

import store from './store';
import i18n from './plugins/i18n';
import router from './router';
import vuetify from './plugins/vuetify';

import TokenExpireInterceptor from './tools/tokenExpireInterceptor.tools';
import './registerServiceWorker';

Axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    TokenExpireInterceptor.tokenExpired(error);
    return Promise.reject(error);
  },
);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
